import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SharedService } from '../../shared/services/shared.service';
import { ReportsService } from '../reports.service';
@Component({
  selector: 'app-reports-dashboard',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.scss'],
})
export class ReportsDashboardComponent implements OnInit, OnDestroy {
  userAccSub: Subscription;
  isLoggedInUser: boolean = false;
  asmEmailDetails: any;
  userReportsSubscription: any;
  reportDetailsSubscription: Subscription;
  reportsList: any = [];
  userName: string = '';
  baseSub: Subscription;
  reportSub: Subscription;

  @Input() dashboard;

  constructor(
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly cd: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private readonly router: Router,
    private readonly service: ReportsService,
    private readonly baseSiteService: BaseSiteService
  ) {}
  baseSiteId: string;
  typesOfReoprts = [
    'Discount savings and summary report',
    'Invoice and credits report',
    'Influenza vaccine report',
    'Product purchase report',
    'Purchasing insights',
  ];
  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.userAccSub = this.user.get().subscribe((res) => {
      if (res && res !== null) {
        this.userName = res['userName'];
        this.isLoggedInUser = true;
        this.service.getReports();
        this.userReportsSubscription = this.service.reportsData$.subscribe(
          (res) => {
            if (res !== null) {
              this.reportsList = res['sanofiMSTRReports'];
              this.reportsList = res['sanofiMSTRReports'].sort(function (a, b) {
                if (a.description < b.description) {
                  return -1;
                }
                if (a.description > b.description) {
                  return 1;
                }
                return 0;
              });
              let temp = this.reportsList[2];
              this.reportsList[2] = this.reportsList[3];
              this.reportsList[3] = temp;
              this.cd.detectChanges();
            }
          }
        );
      } else {
        this.isLoggedInUser = false;
      }
      this.cd.detectChanges();
    });
  }

  openLoginPopup() {
    $('.headerLoginSection').show();
  }

  goToReports() {
    this.router.navigate(['/reportDashboardPage']);
  }

  getreportDetails(reportName) {
    const windowReference = window.open();
    this.reportSub = this.service
      .getreportDetails(reportName, this.userName)
      .subscribe((res) => {
        windowReference.location = decodeURIComponent(res['url']);
      });
  }

  navigateToLogInPage(): void {
    $('.headerLoginSection').show();
    window.scroll(0, 0);
  }

  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.userAccSub?.unsubscribe();
    this.userReportsSubscription?.unsubscribe();
    this.reportDetailsSubscription?.unsubscribe();
    this.reportSub?.unsubscribe();
  }
}
